"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var ToReply = function ToReply(_ref) {
  var fromIdeaUrl = _ref.fromIdeaUrl;
  return (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "idea.merge.to",
    m: "Control"
  }), (0, _preact.h)("br", null), (0, _preact.h)("oembed", {
    url: fromIdeaUrl
  }), (0, _preact.h)("br", null), (0, _preact.h)(_phrase.default, {
    p: "idea.merge.to.votes",
    m: "Control"
  }));
};

var _default = ToReply;
exports.default = _default;